<div class="sticky-top mat-elevation-z6">
    <mat-toolbar class="trip-header-bar bds-toolbar-blue">
        <mat-toolbar-row>
            <span>
                <!-- <fa-icon [icon]="iconFlag" [fixedWidth]="true" size="lg"></fa-icon> -->
                Load / Empty Mismatch
            </span>
            <span class="fill-remaining-space"></span>
            <span>
                <a mat-stroked-button [routerLink]="addTripRouterLink" target="_blank">
                    <!-- <fa-icon [icon]="iconSave"></fa-icon> -->
                    Add New Trip
                </a>
            </span>
        </mat-toolbar-row>
    </mat-toolbar>
</div>
<rt-jeopardized-shipment-reason-common
    [trip]="trip$ | async"
    [showInterfaceValidations]="true"
    [showOriginCriteria]="true"
    [showDestinationCriteria]="true"
    [useExpansionPanel]="false"
    (saveClick)="onTripSaveClicked($event)"
    (popoutTrip)="onPopoutTripclicked($event)"
></rt-jeopardized-shipment-reason-common>
<ng-template #loading> Loading... </ng-template>
